const DOMAINS = ["https://backend.icarius.dev", "https://asistencia.icarius.dev"];
const CLIENT = "";
const USER = "";
const PIN = "";
const GOOGLE_MAPS_KEY = "AIzaSyDl0RXSwdIExaoQTB1nui1ECknJzuFdxXc";
const AG_GRID_KEY = "ALBANY_TECHNOLOGIES_SPA_ALBANY_TECHNOLOGIES_multi_1_Devs__3_January_2021_[v2]_MTYwOTYzMjAwMDAwMA==783c6518dabf3a92fe5f0281f5a08801";

export { DOMAINS, CLIENT, USER, PIN, GOOGLE_MAPS_KEY, AG_GRID_KEY };
